(function () {

    var laroute = (function () {

        var routes = {

            absolute: false,
            rootUrl: 'https://cloud.getslurp.com/',
            routes : [
    {
        "uri": "batcave\/franchise",
        "name": "admin.franchise.index"
    },
    {
        "uri": "batcave\/franchise\/{id}",
        "name": "admin.franchise.show"
    },
    {
        "uri": "batcave\/franchise\/{id}",
        "name": "admin.franchise.update"
    },
    {
        "uri": "batcave\/franchise\/{id}\/activate",
        "name": "admin.franchise.activate"
    },
    {
        "uri": "batcave\/franchise\/{id}\/central",
        "name": "admin.franchise.show.central"
    },
    {
        "uri": "batcave\/franchise\/{id}\/disable",
        "name": "admin.franchise.disable"
    },
    {
        "uri": "batcave\/franchise\/{id}\/features",
        "name": "admin.franchise.store.features"
    },
    {
        "uri": "batcave\/franchise\/{id}\/impersonate",
        "name": "admin.franchise.impersonate"
    },
    {
        "uri": "batcave\/franchise\/{id}\/outlet",
        "name": "admin.franchise.show.outlet"
    },
    {
        "uri": "batcave\/franchise\/{fid}\/outlet\/{oid}\/details",
        "name": "admin.franchise.outlet.kiosk"
    },
    {
        "uri": "batcave\/franchise\/{id}\/transaction",
        "name": "admin.franchise.transaction.check"
    },
    {
        "uri": "batcave\/franchise\/{id}\/transaction-log",
        "name": "admin.franchise.transaction.log"
    },
    {
        "uri": "batcave\/franchise\/{id}\/transaction\/{tid}",
        "name": "admin.franchise.transaction.show"
    },
    {
        "uri": "batcave\/franchise\/{id}\/user",
        "name": "admin.franchise.user.index"
    },
    {
        "uri": "batcave\/franchise\/{fid}\/user",
        "name": "admin.franchise.user.store"
    },
    {
        "uri": "batcave\/franchise\/{fid}\/user\/{uid}",
        "name": "admin.franchise.user.update"
    },
    {
        "uri": "batcave\/franchise\/create",
        "name": "admin.franchise.store"
    },
    {
        "uri": "batcave\/franchise\/init\/{franchise}",
        "name": "admin.franchise.init"
    },
    {
        "uri": "batcave\/franchise\/init\/{franchise}",
        "name": "admin.franchise.performinit"
    },
    {
        "uri": "batcave\/franchise\/expiry-date\/{id}",
        "name": "admin.franchise.store.expirydate"
    },
    {
        "uri": "batcave\/franchise\/{id}\/hardware",
        "name": "admin.franchise.show.hardware"
    },
    {
        "uri": "batcave\/franchise\/{id}\/hardware",
        "name": "admin.franchise.store.hardware"
    },
    {
        "uri": "batcave\/franchise\/{id}\/hardware\/{hid}",
        "name": "admin.franchise.update.hardware"
    },
    {
        "uri": "batcave\/franchise\/{id}\/hardware\/delete",
        "name": "admin.franchise.delete.hardware"
    },
    {
        "uri": "batcave\/central-settings",
        "name": "admin.central_settings.index"
    },
    {
        "uri": "batcave\/central-settings\/group\/{id}",
        "name": "admin.central_settings.group.show"
    },
    {
        "uri": "batcave\/central-settings\/group",
        "name": "admin.central_settings.group.create"
    },
    {
        "uri": "batcave\/central-settings\/group\/{id}",
        "name": "admin.central_settings.group.update"
    },
    {
        "uri": "batcave\/central-settings\/group\/update-sequence",
        "name": "admin.central_settings.group.update_sequence"
    },
    {
        "uri": "batcave\/central-settings\/group\/{id}",
        "name": "admin.central_settings.group.delete"
    },
    {
        "uri": "batcave\/user",
        "name": "admin.user.index"
    },
    {
        "uri": "batcave\/user\/create",
        "name": "admin.user.create"
    },
    {
        "uri": "batcave\/user\/{id}\/impersonate",
        "name": "admin.user.impersonate"
    },
    {
        "uri": "batcave\/branches",
        "name": "admin.branches.index"
    },
    {
        "uri": "batcave\/branches\/create",
        "name": "admin.branches.create"
    },
    {
        "uri": "batcave\/branches\/update",
        "name": "admin.branches.update"
    },
    {
        "uri": "batcave\/branches\/delete",
        "name": "admin.branches.delete"
    },
    {
        "uri": "batcave\/branches\/franchises\/{id}",
        "name": "admin.branches.getFranchise"
    },
    {
        "uri": "batcave\/timezone",
        "name": "admin.timezone"
    },
    {
        "uri": "batcave\/currency",
        "name": "admin.currency"
    },
    {
        "uri": "batcave\/branch",
        "name": "admin.branch"
    },
    {
        "uri": "batcave\/business",
        "name": "admin.business"
    },
    {
        "uri": "api\/batcave\/query",
        "name": "admin.query"
    },
    {
        "uri": "franchise\/category",
        "name": "franchise.inventory.category.store"
    },
    {
        "uri": "franchise\/modifier",
        "name": "franchise.inventory.modifier.store"
    },
    {
        "uri": "franchise\/pricebook",
        "name": "franchise.inventory.pricebook.index"
    },
    {
        "uri": "franchise\/pricebook",
        "name": "franchise.inventory.pricebook.store"
    },
    {
        "uri": "franchise\/pricebook\/{id}",
        "name": "franchise.inventory.pricebook.show"
    },
    {
        "uri": "logout",
        "name": "loyalty.logout"
    },
    {
        "uri": "login",
        "name": "loyalty.login"
    },
    {
        "uri": "login",
        "name": "loyalty.login_attempt"
    },
    {
        "uri": "login\/{phone}\/pwd",
        "name": "loyalty.login_pwd"
    },
    {
        "uri": "check-credential",
        "name": "loyalty.check_credential"
    },
    {
        "uri": "request-code",
        "name": "loyalty.request_code"
    },
    {
        "uri": "confirmation",
        "name": "loyalty.confirmation"
    },
    {
        "uri": "verify-code",
        "name": "loyalty.verify_code"
    },
    {
        "uri": "set-password",
        "name": "loyalty.set_password"
    },
    {
        "uri": "set-password",
        "name": "loyalty.save_password"
    },
    {
        "uri": "\/",
        "name": "loyalty.index"
    },
    {
        "uri": "auth",
        "name": "loyalty.auth"
    },
    {
        "uri": "my-rewards",
        "name": "loyalty.my_rewards"
    },
    {
        "uri": "change-pwd",
        "name": "loyalty.change_pwd"
    },
    {
        "uri": "c\/{hash}",
        "name": "loyalty.customer.confirm"
    },
    {
        "uri": "r\/{hash}",
        "name": "loyalty.redemption"
    },
    {
        "uri": "t\/{hash}",
        "name": "loyalty.receipt"
    },
    {
        "uri": "login",
        "name": "login"
    },
    {
        "uri": "e-invoice-request\/sendEmailSubmittedEInvoice\/{id}",
        "name": "sendEmailSubmittedEInvoice"
    },
    {
        "uri": "e-invoice-request\/refresh",
        "name": "e_invoice_refresh"
    },
    {
        "uri": "e-invoice-request\/report\/{id}",
        "name": "e_invoice_report"
    },
    {
        "uri": "e-invoice-request\/send-email",
        "name": "e_invoice_send_email"
    },
    {
        "uri": "franchise\/device",
        "name": "franchise.setting.device.index"
    },
    {
        "uri": "franchise\/device\/{id}",
        "name": "franchise.setting.device.show"
    },
    {
        "uri": "franchise\/device\/export\/{type}",
        "name": "franchise.setting.device.exportAsFile"
    },
    {
        "uri": "franchise\/device\/generateNewCode",
        "name": "franchise.setting.device.generateNewCode"
    },
    {
        "uri": "franchise\/device\/getDeviceList",
        "name": "franchise.setting.device.getDeviceList"
    },
    {
        "uri": "franchise\/device",
        "name": "franchise.setting.device.store"
    },
    {
        "uri": "franchise\/device\/{id}",
        "name": "franchise.setting.device.update"
    },
    {
        "uri": "franchise\/device\/{id}",
        "name": "franchise.setting.device.delete"
    },
    {
        "uri": "franchise\/measurement",
        "name": "franchise.inventory.measurement.index"
    },
    {
        "uri": "franchise\/measurement\/list",
        "name": "franchise.inventory.measurement.list"
    },
    {
        "uri": "franchise\/measurement\/show\/{id}",
        "name": "franchise.inventory.measurement.show"
    },
    {
        "uri": "franchise\/measurement\/create",
        "name": "franchise.inventory.measurement.create"
    },
    {
        "uri": "franchise\/measurement\/update",
        "name": "franchise.inventory.measurement.update"
    },
    {
        "uri": "franchise\/measurement\/delete",
        "name": "franchise.inventory.measurement.delete"
    },
    {
        "uri": "franchise\/pricebook\/archive",
        "name": "franchise.inventory.pricebook.archive"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/products",
        "name": "franchise.inventory.pricebook.products"
    },
    {
        "uri": "franchise\/pricebook\/edit\/{id}",
        "name": "franchise.inventory.pricebook.edit"
    },
    {
        "uri": "franchise\/pricebook\/{id}",
        "name": "franchise.inventory.pricebook.update"
    },
    {
        "uri": "franchise\/pricebook",
        "name": "franchise.inventory.pricebook.delete"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/export\/{type}",
        "name": "franchise.inventory.pricebook.exportAsFile"
    },
    {
        "uri": "franchise\/pricebook\/import",
        "name": "franchise.inventory.pricebook.import"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/validate\/{importKey}",
        "name": "franchise.inventory.pricebook.validate_data"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/store\/{importKey}",
        "name": "franchise.inventory.pricebook.store_data"
    },
    {
        "uri": "franchise\/pricebook\/read-data\/{importKey}",
        "name": "franchise.inventory.pricebook.readdata"
    },
    {
        "uri": "franchise\/pricebook\/import-status\/{importKey}",
        "name": "franchise.inventory.pricebook.import_status"
    },
    {
        "uri": "franchise\/pricebook\/product-variant-entry\/{id}",
        "name": "franchise.inventory.pricebook.entry.save"
    },
    {
        "uri": "franchise\/pricebook\/product-variant-entry\/{id}\/delete",
        "name": "franchise.inventory.pricebook.entry.delete"
    },
    {
        "uri": "franchise\/pricebook\/hide",
        "name": "franchise.inventory.pricebook.hide"
    },
    {
        "uri": "franchise\/pricebook\/unhide",
        "name": "franchise.inventory.pricebook.unhide"
    },
    {
        "uri": "franchise\/vue\/auth",
        "name": "franchise.vue.auth_user"
    },
    {
        "uri": "franchise\/vue\/categories",
        "name": "franchise.vue.categories"
    },
    {
        "uri": "franchise\/vue\/centrals",
        "name": "franchise.vue.centrals"
    },
    {
        "uri": "franchise\/vue\/checkouts",
        "name": "franchise.vue.checkouts"
    },
    {
        "uri": "franchise\/vue\/discounts",
        "name": "franchise.vue.discounts"
    },
    {
        "uri": "franchise\/vue\/modifiersets",
        "name": "franchise.vue.getmodifiersetsselect"
    },
    {
        "uri": "franchise\/vue\/outlets",
        "name": "franchise.vue.outlets"
    },
    {
        "uri": "franchise\/vue\/check-consolidate",
        "name": "franchise.vue.checkConsolidateStatus"
    },
    {
        "uri": "franchise\/vue\/expiryoutlets",
        "name": "franchise.vue.expiryoutlets"
    },
    {
        "uri": "franchise\/vue\/expirysoonoutlets",
        "name": "franchise.vue.expirysoonoutlets"
    },
    {
        "uri": "franchise\/vue\/check-bill-information",
        "name": "franchise.vue.checkbillinformation"
    },
    {
        "uri": "franchise\/vue\/payments",
        "name": "franchise.vue.payments"
    },
    {
        "uri": "franchise\/vue\/products",
        "name": "franchise.vue.products"
    },
    {
        "uri": "franchise\/vue\/promotions",
        "name": "franchise.vue.promotions"
    },
    {
        "uri": "franchise\/vue\/roles",
        "name": "franchise.vue.roles"
    },
    {
        "uri": "franchise\/vue\/shifts",
        "name": "franchise.vue.shifts"
    },
    {
        "uri": "franchise\/vue\/tags",
        "name": "franchise.vue.tags"
    },
    {
        "uri": "franchise\/vue\/parent-tags",
        "name": "franchise.vue.parent.tags"
    },
    {
        "uri": "franchise\/vue\/taxes",
        "name": "franchise.vue.gettaxselect"
    },
    {
        "uri": "franchise\/vue\/targets",
        "name": "franchise.vue.getTargetList"
    },
    {
        "uri": "franchise\/vue\/users",
        "name": "franchise.vue.users"
    },
    {
        "uri": "franchise\/vue\/variants",
        "name": "franchise.vue.variants"
    },
    {
        "uri": "franchise\/vue\/account",
        "name": "franchise.vue.account"
    },
    {
        "uri": "franchise\/vue\/staffs",
        "name": "franchise.vue.staffs"
    },
    {
        "uri": "franchise\/vue\/timezone",
        "name": "franchise.vue.timezone"
    },
    {
        "uri": "franchise\/vue\/state",
        "name": "franchise.vue.state"
    },
    {
        "uri": "franchise\/vue\/categoryBusiness",
        "name": "franchise.vue.categoryBusiness"
    },
    {
        "uri": "franchise\/vue\/currency",
        "name": "franchise.vue.currency"
    },
    {
        "uri": "franchise\/vue\/branch",
        "name": "franchise.vue.branch"
    },
    {
        "uri": "franchise\/vue\/business",
        "name": "franchise.vue.business"
    },
    {
        "uri": "franchise\/report\/tax",
        "name": "franchise.report.tax.index"
    },
    {
        "uri": "franchise\/report\/tax\/export\/{type}",
        "name": "franchise.report.tax.exportAsFile"
    },
    {
        "uri": "franchise\/report\/tax\/{id}\/summary",
        "name": "franchise.report.tax.getTaxSummary"
    },
    {
        "uri": "franchise\/report\/drawer-session",
        "name": "franchise.report.drawersession.index"
    },
    {
        "uri": "franchise\/report\/drawer-session\/{id}",
        "name": "franchise.report.drawersession.show"
    },
    {
        "uri": "franchise\/report\/drawer-session\/export\/{type}",
        "name": "franchise.report.drawersession.exportAsFile"
    },
    {
        "uri": "franchise\/report\/drawer-session\/list",
        "name": "franchise.report.drawersession.drawerSessionList"
    },
    {
        "uri": "franchise\/report\/drawer-session\/drawersession\/export\/{id}",
        "name": "franchise.report.drawersession.exportDrawerAsFile"
    },
    {
        "uri": "franchise\/report\/drawer-session\/central-setting",
        "name": "franchise.report.drawersession.getCentralSetting"
    },
    {
        "uri": "franchise\/report\/settlement",
        "name": "franchise.report.settlement.index"
    },
    {
        "uri": "franchise\/report\/settlement\/table",
        "name": "franchise.report.settlement.table"
    },
    {
        "uri": "franchise\/report\/settlement\/download\/{merchant_id}\/{id}",
        "name": "franchise.report.settlement.download"
    },
    {
        "uri": "franchise\/report\/promotion",
        "name": "franchise.report.promotion.index"
    },
    {
        "uri": "franchise\/report\/promotion\/sales",
        "name": "franchise.report.promotion.sales.index"
    },
    {
        "uri": "franchise\/report\/promotion\/sales\/export\/{type}",
        "name": "franchise.report.promotion.sales.export"
    },
    {
        "uri": "franchise\/report\/snapshot",
        "name": "franchise.report.snapshot.index"
    },
    {
        "uri": "franchise\/report\/snapshot\/{outlet_id}\/graph\/{type}",
        "name": "franchise.report.snapshot.exportGraphData"
    },
    {
        "uri": "franchise\/report\/snapshot\/{id}\/summary",
        "name": "franchise.report.snapshot.getSnapshotSummary"
    },
    {
        "uri": "franchise\/report\/snapshot\/export\/{type}",
        "name": "franchise.report.snapshot.exportAsFile"
    },
    {
        "uri": "franchise\/report\/snapshot\/product",
        "name": "franchise.report.snapshot.product"
    },
    {
        "uri": "franchise\/report\/product",
        "name": "franchise.report.item.index"
    },
    {
        "uri": "franchise\/report\/product\/{id}\/summary",
        "name": "franchise.report.item.getChartSummary"
    },
    {
        "uri": "franchise\/report\/product\/export\/{type}",
        "name": "franchise.report.item.exportChartAsFile"
    },
    {
        "uri": "franchise\/report\/product\/tag-sales",
        "name": "franchise.report.item.getTagSales"
    },
    {
        "uri": "franchise\/report\/product\/tag-sales-export\/{type}",
        "name": "franchise.report.item.exportTagSalesAsFile"
    },
    {
        "uri": "franchise\/report\/product\/category-sales",
        "name": "franchise.report.item.category_sales"
    },
    {
        "uri": "franchise\/report\/product\/export-category-sales\/{type}",
        "name": "franchise.report.item.export_category_sales"
    },
    {
        "uri": "franchise\/report\/product\/variant",
        "name": "franchise.report.item.variant.index"
    },
    {
        "uri": "franchise\/report\/product\/variant\/export\/{type}",
        "name": "franchise.report.item.variant.export"
    },
    {
        "uri": "franchise\/report\/product\/staff",
        "name": "franchise.report.item.staff.index"
    },
    {
        "uri": "franchise\/report\/product\/staff\/export\/{type}",
        "name": "franchise.report.item.staff.export"
    },
    {
        "uri": "franchise\/report\/voided-sales",
        "name": "franchise.report.voidedsales.index"
    },
    {
        "uri": "franchise\/report\/voided-sales\/voided-orders",
        "name": "franchise.report.voidedsales.voided_orders"
    },
    {
        "uri": "franchise\/report\/voided-sales\/export-voided-orders\/{type}",
        "name": "franchise.report.voidedsales.voided_orders_export"
    },
    {
        "uri": "franchise\/report\/voided-sales\/{id}\/summary",
        "name": "franchise.report.voidedsales.getSummary"
    },
    {
        "uri": "franchise\/report\/voided-sales\/export\/{type}",
        "name": "franchise.report.voidedsales.exportAsFile"
    },
    {
        "uri": "franchise\/report\/monthly",
        "name": "franchise.report.monthly.index"
    },
    {
        "uri": "franchise\/report\/monthly\/{id}\/graph\/{type}",
        "name": "franchise.report.monthly.exportGraphData"
    },
    {
        "uri": "franchise\/report\/monthly\/{id}\/summary",
        "name": "franchise.report.monthly.getMonthlySummary"
    },
    {
        "uri": "franchise\/report\/monthly\/export\/{type}",
        "name": "franchise.report.monthly.exportAsFile"
    },
    {
        "uri": "franchise\/report\/transaction",
        "name": "franchise.report.transaction.index"
    },
    {
        "uri": "franchise\/report\/transaction\/all-transactions",
        "name": "franchise.report.transaction.all"
    },
    {
        "uri": "franchise\/report\/transaction\/cash-transactions",
        "name": "franchise.report.transaction.cash"
    },
    {
        "uri": "franchise\/report\/transaction\/credit-transactions",
        "name": "franchise.report.transaction.credit"
    },
    {
        "uri": "franchise\/report\/transaction\/cheque-transactions",
        "name": "franchise.report.transaction.cheque"
    },
    {
        "uri": "franchise\/report\/transaction\/voucher-transactions",
        "name": "franchise.report.transaction.voucher"
    },
    {
        "uri": "franchise\/report\/transaction\/other-transactions",
        "name": "franchise.report.transaction.other"
    },
    {
        "uri": "franchise\/report\/transaction\/{id}\/transaction-sum",
        "name": "franchise.report.transaction.getSumTransactionType"
    },
    {
        "uri": "franchise\/report\/transaction\/graph\/{type}",
        "name": "franchise.report.transaction.export_graph"
    },
    {
        "uri": "franchise\/report\/transaction\/{id}\/graph-transaction\/{type?}",
        "name": "franchise.report.transaction.graphTransaction"
    },
    {
        "uri": "franchise\/report\/transaction\/{id}\/receipt",
        "name": "franchise.report.transaction.getTransactionReceipt"
    },
    {
        "uri": "franchise\/report\/transaction\/breakdown",
        "name": "franchise.report.transaction.breakdown"
    },
    {
        "uri": "franchise\/report\/transaction\/export-breakdown\/{type}",
        "name": "franchise.report.transaction.breakdown_export"
    },
    {
        "uri": "franchise\/report\/transaction\/breakdown-details",
        "name": "franchise.report.transaction.breakdown_details"
    },
    {
        "uri": "franchise\/report\/transaction\/export-breakdown-details\/{type}",
        "name": "franchise.report.transaction.breakdown_details_export"
    },
    {
        "uri": "franchise\/report\/transaction\/export\/{type}",
        "name": "franchise.report.transaction.exportAsFile"
    },
    {
        "uri": "franchise\/report\/transaction\/export-transaction-breakdown-details\/{type}",
        "name": "franchise.report.transaction.transaction_breakdown_details_export"
    },
    {
        "uri": "franchise\/report\/transaction\/{id}\/export",
        "name": "franchise.report.transaction.exportReceipt"
    },
    {
        "uri": "franchise\/report\/transaction\/first\/{outletId}",
        "name": "franchise.report.transaction.first"
    },
    {
        "uri": "franchise\/report\/modifier",
        "name": "franchise.report.modifier.index"
    },
    {
        "uri": "franchise\/report\/modifier\/export\/{type}",
        "name": "franchise.report.modifier.exportAsFile"
    },
    {
        "uri": "franchise\/report\/staff-attendance",
        "name": "franchise.report.staff_attendance.index"
    },
    {
        "uri": "franchise\/report\/staff-attendance\/attendance-list",
        "name": "franchise.report.staff_attendance.attendance_list"
    },
    {
        "uri": "franchise\/report\/staff-attendance\/attendance-summary",
        "name": "franchise.report.staff_attendance.attendance_summary"
    },
    {
        "uri": "franchise\/report\/staff-attendance\/export-attendance\/{type}",
        "name": "franchise.report.staff_attendance.export_attendance"
    },
    {
        "uri": "franchise\/report\/staff-attendance\/export-attendance-summary\/{type}",
        "name": "franchise.report.staff_attendance.export_attendance_summary"
    },
    {
        "uri": "franchise\/report\/staff-attendance\/export-attendance-individual\/{staff_id}\/{type}",
        "name": "franchise.report.staff_attendance.export_attendance_individual"
    },
    {
        "uri": "franchise\/report\/cash-adjustment",
        "name": "franchise.report.cash_adjustments.index"
    },
    {
        "uri": "franchise\/report\/cash-adjustment\/all",
        "name": "franchise.report.cash_adjustments.all"
    },
    {
        "uri": "franchise\/report\/cash-adjustment\/summary",
        "name": "franchise.report.cash_adjustments.summary"
    },
    {
        "uri": "franchise\/report\/cash-adjustment\/export\/{type}",
        "name": "franchise.report.cash_adjustments.export"
    },
    {
        "uri": "franchise\/report\/hourly",
        "name": "franchise.report.hourly.index"
    },
    {
        "uri": "franchise\/report\/hourly\/{id}\/graph\/{type}",
        "name": "franchise.report.hourly.exportGraphData"
    },
    {
        "uri": "franchise\/report\/hourly\/{id}\/summary",
        "name": "franchise.report.hourly.getHourlySummary"
    },
    {
        "uri": "franchise\/report\/hourly\/export\/{type}",
        "name": "franchise.report.hourly.exportAsFile"
    },
    {
        "uri": "franchise\/report\/discount",
        "name": "franchise.report.discount.index"
    },
    {
        "uri": "franchise\/report\/discount\/{id}\/summary",
        "name": "franchise.report.discount.getSummary"
    },
    {
        "uri": "franchise\/report\/discount\/export\/{type}",
        "name": "franchise.report.discount.exportAsFile"
    },
    {
        "uri": "franchise\/dashboard\/stats",
        "name": "franchise.dashboard.stats"
    },
    {
        "uri": "franchise\/dashboard\/target-sales",
        "name": "franchise.dashboard.getMonthlyTargetSales"
    },
    {
        "uri": "franchise\/dashboard\/export\/{type}",
        "name": "franchise.dashboard.exportStatsAsCSV"
    },
    {
        "uri": "franchise\/tax",
        "name": "franchise.inventory.tax.index"
    },
    {
        "uri": "franchise\/tax\/{id}",
        "name": "franchise.inventory.tax.show"
    },
    {
        "uri": "franchise\/tax\/export\/{type}",
        "name": "franchise.inventory.tax.exportAsFile"
    },
    {
        "uri": "franchise\/tax",
        "name": "franchise.inventory.tax.store"
    },
    {
        "uri": "franchise\/tax",
        "name": "franchise.inventory.tax.delete"
    },
    {
        "uri": "franchise\/tax\/{id}",
        "name": "franchise.inventory.tax.update"
    },
    {
        "uri": "franchise\/order-layout",
        "name": "franchise.order_layout.index"
    },
    {
        "uri": "franchise\/order-layout\/{id}",
        "name": "franchise.order_layout.show"
    },
    {
        "uri": "franchise\/order-layout\/group",
        "name": "franchise.order_layout.group.index"
    },
    {
        "uri": "franchise\/order-layout",
        "name": "franchise.order_layout.create"
    },
    {
        "uri": "franchise\/order-layout\/{id}",
        "name": "franchise.order_layout.update"
    },
    {
        "uri": "franchise\/order-layout\/{id}",
        "name": "franchise.order_layout.clone"
    },
    {
        "uri": "franchise\/order-layout",
        "name": "franchise.order_layout.delete"
    },
    {
        "uri": "franchise\/order-layout\/group",
        "name": "franchise.order_layout.group.create"
    },
    {
        "uri": "franchise\/order-layout\/group\/{id}",
        "name": "franchise.order_layout.group.update"
    },
    {
        "uri": "franchise\/order-layout\/group\/{id}",
        "name": "franchise.order_layout.group.delete"
    },
    {
        "uri": "franchise\/loyalty\/redemption",
        "name": "franchise.loyalty.redemption.index"
    },
    {
        "uri": "franchise\/loyalty\/redemption\/{id}",
        "name": "franchise.loyalty.redemption.show"
    },
    {
        "uri": "franchise\/loyalty\/redemption\/eligibility",
        "name": "franchise.loyalty.redemption.eligibility_count"
    },
    {
        "uri": "franchise\/loyalty\/settings",
        "name": "franchise.loyalty.settings.index"
    },
    {
        "uri": "franchise\/loyalty\/sms\/balance",
        "name": "franchise.loyalty.sms.balance"
    },
    {
        "uri": "franchise\/loyalty\/sms\/packages",
        "name": "franchise.loyalty.sms.packages"
    },
    {
        "uri": "franchise\/loyalty\/sms\/payment-confirmed",
        "name": "franchise.loyalty.sms.payment_confirmed"
    },
    {
        "uri": "franchise\/loyalty\/redemption",
        "name": "franchise.loyalty.redemption.store"
    },
    {
        "uri": "franchise\/loyalty\/redemption\/{id}",
        "name": "franchise.loyalty.redemption.update"
    },
    {
        "uri": "franchise\/loyalty\/redemption\/delete",
        "name": "franchise.loyalty.redemption.bulkdelete"
    },
    {
        "uri": "franchise\/loyalty\/redemption\/update",
        "name": "franchise.loyalty.redemption.bulkupdate"
    },
    {
        "uri": "franchise\/loyalty\/settings",
        "name": "franchise.loyalty.settings.update"
    },
    {
        "uri": "franchise\/loyalty\/sms\/packages\/{id}\/bill",
        "name": "franchise.loyalty.sms.package_bill"
    },
    {
        "uri": "franchise\/loyalty\/payment-confirmed",
        "name": "franchise.loyalty.sms.payment_confirmed"
    },
    {
        "uri": "franchise\/profile",
        "name": "franchise.profile.index"
    },
    {
        "uri": "franchise\/profile",
        "name": "franchise.profile.update"
    },
    {
        "uri": "franchise\/profile\/media",
        "name": "franchise.profile.media"
    },
    {
        "uri": "franchise\/profile\/password",
        "name": "franchise.profile.password.update"
    },
    {
        "uri": "franchise\/charge",
        "name": "franchise.inventory.charge.index"
    },
    {
        "uri": "franchise\/charge\/{id}",
        "name": "franchise.inventory.charge.show"
    },
    {
        "uri": "franchise\/charge\/export\/{type}",
        "name": "franchise.inventory.charge.exportAsFile"
    },
    {
        "uri": "franchise\/charge",
        "name": "franchise.inventory.charge.store"
    },
    {
        "uri": "franchise\/charge",
        "name": "franchise.inventory.charge.delete"
    },
    {
        "uri": "franchise\/charge\/{id}",
        "name": "franchise.inventory.charge.update"
    },
    {
        "uri": "franchise\/staff\/role",
        "name": "franchise.staff.role.index"
    },
    {
        "uri": "franchise\/staff\/role\/store",
        "name": "franchise.staff.role.store"
    },
    {
        "uri": "franchise\/staff\/role\/{id}",
        "name": "franchise.staff.role.update"
    },
    {
        "uri": "franchise\/staff\/role\/delete",
        "name": "franchise.staff.role.delete"
    },
    {
        "uri": "franchise\/user",
        "name": "franchise.user.index"
    },
    {
        "uri": "franchise\/user",
        "name": "franchise.user.store"
    },
    {
        "uri": "franchise\/user\/{id}",
        "name": "franchise.user.update"
    },
    {
        "uri": "franchise\/user\/{id}\/media",
        "name": "franchise.user.storemedia"
    },
    {
        "uri": "franchise\/user\/delete",
        "name": "franchise.user.delete"
    },
    {
        "uri": "franchise\/user\/update",
        "name": "franchise.user.bulkupdate"
    },
    {
        "uri": "franchise\/e-invoice\/taxpayer",
        "name": "franchise.e-invoice.taxpayer"
    },
    {
        "uri": "franchise\/e-invoice\/invoice",
        "name": "franchise.e-invoice.invoice"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated",
        "name": "franchise.e-invoice.consolidated"
    },
    {
        "uri": "franchise\/e-invoice\/setting",
        "name": "franchise.e-invoice.setting"
    },
    {
        "uri": "franchise\/e-invoice\/business",
        "name": "franchise.e-invoice.business.index"
    },
    {
        "uri": "franchise\/e-invoice\/business\/show\/{id}",
        "name": "franchise.e-invoice.business.show"
    },
    {
        "uri": "franchise\/e-invoice\/business\/create",
        "name": "franchise.e-invoice.business.create"
    },
    {
        "uri": "franchise\/e-invoice\/business\/store",
        "name": "franchise.e-invoice.business.store"
    },
    {
        "uri": "franchise\/e-invoice\/business\/edit\/{id}",
        "name": "franchise.e-invoice.business.edit"
    },
    {
        "uri": "franchise\/e-invoice\/business\/update\/{id}",
        "name": "franchise.e-invoice.business.update"
    },
    {
        "uri": "franchise\/e-invoice\/outlet",
        "name": "franchise.e-invoice.outlet.index"
    },
    {
        "uri": "franchise\/e-invoice\/outlet\/show\/{id}",
        "name": "franchise.e-invoice.outlet.show"
    },
    {
        "uri": "franchise\/e-invoice\/outlet\/edit\/{id}",
        "name": "franchise.e-invoice.outlet.edit"
    },
    {
        "uri": "franchise\/e-invoice\/outlet\/update\/{id}",
        "name": "franchise.e-invoice.outlet.update"
    },
    {
        "uri": "franchise\/e-invoice\/invoice\/{id}",
        "name": "franchise.e-invoice.invoice.show"
    },
    {
        "uri": "franchise\/e-invoice\/invoice\/summary",
        "name": "franchise.e-invoice.invoice.summary"
    },
    {
        "uri": "franchise\/e-invoice\/invoice\/list",
        "name": "franchise.e-invoice.invoice.index"
    },
    {
        "uri": "franchise\/e-invoice\/invoice\/list\/{id}",
        "name": "franchise.e-invoice.invoice.get"
    },
    {
        "uri": "franchise\/e-invoice\/invoice\/validate",
        "name": "franchise.e-invoice.invoice.validate"
    },
    {
        "uri": "franchise\/e-invoice\/invoice\/export\/{type}",
        "name": "franchise.e-invoice.invoice.exportAsFile"
    },
    {
        "uri": "franchise\/e-invoice\/invoice\/remove\/bulk",
        "name": "franchise.e-invoice.invoice.removeBulk"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/{id}",
        "name": "franchise.e-invoice.consolidated.show"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/getDetails",
        "name": "franchise.e-invoice.consolidated.getDetails"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/summary",
        "name": "franchise.e-invoice.consolidated.summary"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/list",
        "name": "franchise.e-invoice.consolidated.index"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/validate",
        "name": "franchise.e-invoice.consolidated.validate"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/refresh",
        "name": "franchise.e-invoice.consolidated.refresh"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/validate\/bulk",
        "name": "franchise.e-invoice.consolidated.validateBulk"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/credit-note\/bulk",
        "name": "franchise.e-invoice.consolidated.creditNoteBulk"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/debit-note\/bulk",
        "name": "franchise.e-invoice.consolidated.debitNoteBulk"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/cancel\/bulk",
        "name": "franchise.e-invoice.consolidated.cancelBulk"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/remove\/bulk",
        "name": "franchise.e-invoice.consolidated.removeBulk"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/refresh\/bulk",
        "name": "franchise.e-invoice.consolidated.refreshBulk"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/report\/{id}",
        "name": "franchise.e-invoice.consolidated.report"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/validation\/{id}",
        "name": "franchise.e-invoice.consolidated.validation"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/transaction\/{id}",
        "name": "franchise.e-invoice.consolidated.transaction"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/tax-transaction\/{id}",
        "name": "franchise.e-invoice.consolidated.tax_transaction"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/total-transaction\/{id}",
        "name": "franchise.e-invoice.consolidated.total_transaction"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/export\/{type}",
        "name": "franchise.e-invoice.consolidated.exportAsFile"
    },
    {
        "uri": "franchise\/e-invoice\/consolidated\/export\/invoice\/{type}",
        "name": "franchise.e-invoice.consolidated.invoice.exportAsFile"
    },
    {
        "uri": "franchise\/e-invoice\/setting\/store",
        "name": "franchise.e-invoice.setting.store"
    },
    {
        "uri": "franchise\/voucher",
        "name": "franchise.inventory.coupon.index"
    },
    {
        "uri": "franchise\/voucher\/redemptions",
        "name": "franchise.inventory.coupon.redemptions"
    },
    {
        "uri": "franchise\/voucher\/invoices",
        "name": "franchise.inventory.coupon.invoices"
    },
    {
        "uri": "franchise\/voucher\/{id}",
        "name": "franchise.inventory.coupon.show"
    },
    {
        "uri": "franchise\/voucher\/export\/{type}",
        "name": "franchise.inventory.coupon.exportAsFile"
    },
    {
        "uri": "franchise\/voucher",
        "name": "franchise.inventory.coupon.store"
    },
    {
        "uri": "franchise\/voucher\/{id}",
        "name": "franchise.inventory.coupon.update"
    },
    {
        "uri": "franchise\/voucher\/{outlet_id?}",
        "name": "franchise.inventory.coupon.delete"
    },
    {
        "uri": "franchise\/voucher\/addMedia",
        "name": "franchise.inventory.coupon.addmedia"
    },
    {
        "uri": "franchise\/promotion",
        "name": "franchise.promotion.index"
    },
    {
        "uri": "franchise\/promotion\/{id}",
        "name": "franchise.promotion.show"
    },
    {
        "uri": "franchise\/promotion",
        "name": "franchise.promotion.store"
    },
    {
        "uri": "franchise\/promotion\/{id}",
        "name": "franchise.promotion.update"
    },
    {
        "uri": "franchise\/promotion\/create",
        "name": "franchise.promotion.create"
    },
    {
        "uri": "franchise\/promotion",
        "name": "franchise.promotion.delete"
    },
    {
        "uri": "franchise\/settings",
        "name": "franchise.setting.index"
    },
    {
        "uri": "franchise\/settings\/target\/{outlet_id}",
        "name": "franchise.setting.outlet.getOutletTarget"
    },
    {
        "uri": "franchise\/settings\/target\/{outlet_id}",
        "name": "franchise.setting.outlet.saveOutletTarget"
    },
    {
        "uri": "franchise\/outlet",
        "name": "franchise.outlet.index"
    },
    {
        "uri": "franchise\/outlet\/{id}",
        "name": "franchise.outlet.show"
    },
    {
        "uri": "franchise\/outlet",
        "name": "franchise.outlet.store"
    },
    {
        "uri": "franchise\/outlet\/addmedia",
        "name": "franchise.outlet.addmedia"
    },
    {
        "uri": "franchise\/outlet\/{id}",
        "name": "franchise.outlet.update"
    },
    {
        "uri": "franchise\/outlet\/{id}",
        "name": "franchise.outlet.delete"
    },
    {
        "uri": "franchise\/outlet\/preference\/{outlet_id}",
        "name": "franchise.outlet.savePreference"
    },
    {
        "uri": "franchise\/outlet\/tax\/{id}\/datatable",
        "name": "franchise.outlet.tax.getOutletTaxesDatatable"
    },
    {
        "uri": "franchise\/outlet\/tax\/{id}",
        "name": "franchise.outlet.tax.getOutletTaxes"
    },
    {
        "uri": "franchise\/outlet\/tax\/{outlet_id}\/{tax_id}",
        "name": "franchise.outlet.tax.getOutletTax"
    },
    {
        "uri": "franchise\/outlet\/tax\/assign\/{outlet_id}",
        "name": "franchise.outlet.tax.assignOutletTax"
    },
    {
        "uri": "franchise\/outlet\/tax\/update\/{outlet_id}",
        "name": "franchise.outlet.tax.updateOutletTax"
    },
    {
        "uri": "franchise\/outlet\/tax\/remove\/{outlet_id}",
        "name": "franchise.outlet.tax.removeOutletTaxes"
    },
    {
        "uri": "franchise\/outlet\/drawerSession\/{outlet_id}",
        "name": "franchise.outlet.drawerSession.getDrawerSessionList"
    },
    {
        "uri": "franchise\/outlet\/{outlet_id}\/staff\/staffsales",
        "name": "franchise.outlet.staff.staffsales"
    },
    {
        "uri": "franchise\/outlet\/{outlet_id}\/staff\/export\/{type}",
        "name": "franchise.outlet.staff.exportstaffsales"
    },
    {
        "uri": "franchise\/outlet\/{outlet_id}\/staff\/getTodaySalesAndPaxByOutletStaff",
        "name": "franchise.outlet.staff.todaySalesAndPax"
    },
    {
        "uri": "franchise\/product",
        "name": "franchise.inventory.item.index"
    },
    {
        "uri": "franchise\/product\/archive",
        "name": "franchise.inventory.item.archive"
    },
    {
        "uri": "franchise\/product\/{id}",
        "name": "franchise.inventory.item.show"
    },
    {
        "uri": "franchise\/product\/export\/{type}",
        "name": "franchise.inventory.item.exportAsFile"
    },
    {
        "uri": "franchise\/product",
        "name": "franchise.inventory.item.store"
    },
    {
        "uri": "franchise\/product\/{id}",
        "name": "franchise.inventory.item.update"
    },
    {
        "uri": "franchise\/product\/{outlet_id?}",
        "name": "franchise.inventory.item.delete"
    },
    {
        "uri": "franchise\/product\/restore",
        "name": "franchise.inventory.item.restore"
    },
    {
        "uri": "franchise\/product\/media",
        "name": "franchise.inventory.item.addmedia"
    },
    {
        "uri": "franchise\/product\/import",
        "name": "franchise.inventory.item.import"
    },
    {
        "uri": "franchise\/product\/validate\/{importKey}",
        "name": "franchise.inventory.item.validate_data"
    },
    {
        "uri": "franchise\/product\/store\/{importKey}",
        "name": "franchise.inventory.item.store_data"
    },
    {
        "uri": "franchise\/product\/read-data\/{importKey}",
        "name": "franchise.inventory.item.readdata"
    },
    {
        "uri": "franchise\/product\/update",
        "name": "franchise.inventory.item.bulkUpdate"
    },
    {
        "uri": "franchise\/product\/import-status\/{importKey}",
        "name": "franchise.inventory.item.import_status"
    },
    {
        "uri": "franchise\/access-token",
        "name": "franchise.setting.access.token.index"
    },
    {
        "uri": "franchise\/access-token\/list",
        "name": "franchise.setting.access.token.list"
    },
    {
        "uri": "franchise\/access-token",
        "name": "franchise.setting.access.token.generate"
    },
    {
        "uri": "franchise\/access-token",
        "name": "franchise.setting.access.token.update"
    },
    {
        "uri": "franchise\/access-token",
        "name": "franchise.setting.access.token.revoke"
    },
    {
        "uri": "franchise\/purchase\/invoice\/{id}",
        "name": "franchise.purchase.invoice"
    },
    {
        "uri": "franchise\/purchase\/getPurchaseList",
        "name": "franchise.purchase.getPurchaseList"
    },
    {
        "uri": "franchise\/checkout\/{id}",
        "name": "franchise.checkout.show"
    },
    {
        "uri": "franchise\/settings\/central-settings",
        "name": "franchise.setting.central_settings.set.index"
    },
    {
        "uri": "franchise\/settings\/central-settings\/{id}",
        "name": "franchise.setting.central_settings.set.show"
    },
    {
        "uri": "franchise\/settings\/central-settings\/assigned-outlets",
        "name": "franchise.setting.central_settings.set.assigned_outlets"
    },
    {
        "uri": "franchise\/settings\/central-settings",
        "name": "franchise.setting.central_settings.set.create"
    },
    {
        "uri": "franchise\/settings\/central-settings\/{id}",
        "name": "franchise.setting.central_settings.set.update"
    },
    {
        "uri": "franchise\/settings\/central-settings",
        "name": "franchise.setting.central_settings.set.delete"
    },
    {
        "uri": "franchise\/staff",
        "name": "franchise.staff.index"
    },
    {
        "uri": "franchise\/staff\/{id}",
        "name": "franchise.staff.show"
    },
    {
        "uri": "franchise\/staff\/{id}\/attendance",
        "name": "franchise.staff.attendance"
    },
    {
        "uri": "franchise\/staff\/roles",
        "name": "franchise.staff.getRolesAndPermissions"
    },
    {
        "uri": "franchise\/staff\/permission\/list",
        "name": "franchise.staff.permissionList"
    },
    {
        "uri": "franchise\/staff\/restore\/list",
        "name": "franchise.staff.restoreStaffList"
    },
    {
        "uri": "franchise\/staff",
        "name": "franchise.staff.store"
    },
    {
        "uri": "franchise\/staff\/{id}",
        "name": "franchise.staff.update"
    },
    {
        "uri": "franchise\/staff\/{id}",
        "name": "franchise.staff.delete"
    },
    {
        "uri": "franchise\/staff\/delete",
        "name": "franchise.staff.bulkDelete"
    },
    {
        "uri": "franchise\/staff\/addMedia",
        "name": "franchise.staff.addMedia"
    },
    {
        "uri": "franchise\/staff\/update",
        "name": "franchise.staff.bulkUpdate"
    },
    {
        "uri": "franchise\/staff\/restore",
        "name": "franchise.staff.restoreStaffsAction"
    },
    {
        "uri": "franchise\/voucher-redeem",
        "name": "franchise.inventory.voucher-redeem.index"
    },
    {
        "uri": "franchise\/voucher-redeem\/redemptions",
        "name": "franchise.inventory.voucher-redeem.redemptions"
    },
    {
        "uri": "franchise\/voucher-redeem\/invoices",
        "name": "franchise.inventory.voucher-redeem.invoices"
    },
    {
        "uri": "franchise\/voucher-redeem\/{id}",
        "name": "franchise.inventory.voucher-redeem.show"
    },
    {
        "uri": "franchise\/voucher-redeem\/export\/{type}",
        "name": "franchise.inventory.voucher-redeem.exportAsFile"
    },
    {
        "uri": "franchise\/voucher-redeem",
        "name": "franchise.inventory.voucher-redeem.store"
    },
    {
        "uri": "franchise\/voucher-redeem\/{id}",
        "name": "franchise.inventory.voucher-redeem.update"
    },
    {
        "uri": "franchise\/voucher-redeem\/{outlet_id?}",
        "name": "franchise.inventory.voucher-redeem.delete"
    },
    {
        "uri": "franchise\/voucher-redeem\/addMedia",
        "name": "franchise.inventory.voucher-redeem.addmedia"
    },
    {
        "uri": "franchise\/voucher-redeem\/exportRedemption\/{type}",
        "name": "franchise.inventory.voucher-redeem.exportRedemption"
    },
    {
        "uri": "franchise\/voucher-redeem\/exportInvoice\/{type}",
        "name": "franchise.inventory.voucher-redeem.exportInvoice"
    },
    {
        "uri": "franchise\/payment",
        "name": "franchise.setting.payment.index"
    },
    {
        "uri": "franchise\/payment\/restore",
        "name": "franchise.setting.payment.restore"
    },
    {
        "uri": "franchise\/payment\/{id}",
        "name": "franchise.setting.payment.show"
    },
    {
        "uri": "franchise\/payment\/{source}",
        "name": "franchise.setting.payment.show.source"
    },
    {
        "uri": "franchise\/payment",
        "name": "franchise.setting.payment.store"
    },
    {
        "uri": "franchise\/payment\/{id}",
        "name": "franchise.setting.payment.update"
    },
    {
        "uri": "franchise\/payment",
        "name": "franchise.setting.payment.delete"
    },
    {
        "uri": "franchise\/payment\/undelete",
        "name": "franchise.setting.payment.undelete"
    },
    {
        "uri": "franchise\/billing\/getOutlets",
        "name": "franchise.billing.getOutlets"
    },
    {
        "uri": "franchise\/billing\/getOutlet\/{id}",
        "name": "franchise.billing.getOutlet"
    },
    {
        "uri": "franchise\/billing\/purchase",
        "name": "franchise.billing.purchase"
    },
    {
        "uri": "franchise\/billing\/callback",
        "name": "franchise.billing.callback"
    },
    {
        "uri": "franchise\/billing\/getPurchase\/{id}",
        "name": "franchise.billing.getPurchase"
    },
    {
        "uri": "franchise\/billing\/pay",
        "name": "franchise.billing.pay"
    },
    {
        "uri": "franchise\/category",
        "name": "franchise.inventory.category.index"
    },
    {
        "uri": "franchise\/category\/{id}",
        "name": "franchise.inventory.category.show"
    },
    {
        "uri": "franchise\/category\/export\/{type}",
        "name": "franchise.inventory.category.export"
    },
    {
        "uri": "franchise\/category",
        "name": "franchise.inventory.category.delete"
    },
    {
        "uri": "franchise\/category\/{id}",
        "name": "franchise.inventory.category.update"
    },
    {
        "uri": "franchise\/presetreason",
        "name": "franchise.setting.presetreason.index"
    },
    {
        "uri": "franchise\/presetreason\/{id}",
        "name": "franchise.setting.presetreason.show"
    },
    {
        "uri": "franchise\/presetreason\/export\/{type}",
        "name": "franchise.setting.presetreason.exportAsFile"
    },
    {
        "uri": "franchise\/presetreason",
        "name": "franchise.setting.presetreason.store"
    },
    {
        "uri": "franchise\/presetreason\/{id}",
        "name": "franchise.setting.presetreason.update"
    },
    {
        "uri": "franchise\/presetreason",
        "name": "franchise.setting.presetreason.delete"
    },
    {
        "uri": "franchise\/ingredient",
        "name": "franchise.inventory.ingredient.index"
    },
    {
        "uri": "franchise\/ingredient\/show\/{id}",
        "name": "franchise.inventory.ingredient.show"
    },
    {
        "uri": "franchise\/ingredient\/list",
        "name": "franchise.inventory.ingredient.list"
    },
    {
        "uri": "franchise\/ingredient\/create",
        "name": "franchise.inventory.ingredient.create"
    },
    {
        "uri": "franchise\/ingredient\/update",
        "name": "franchise.inventory.ingredient.update"
    },
    {
        "uri": "franchise\/ingredient\/delete",
        "name": "franchise.inventory.ingredient.delete"
    },
    {
        "uri": "franchise\/tag",
        "name": "franchise.inventory.tags.index"
    },
    {
        "uri": "franchise\/tag\/vue\/tag",
        "name": "franchise.inventory.tags.vue.getvuetabletag"
    },
    {
        "uri": "franchise\/tag\/show\/{id}",
        "name": "franchise.inventory.tags.show"
    },
    {
        "uri": "franchise\/tag\/export\/{type}",
        "name": "franchise.inventory.tags.exportAsFile"
    },
    {
        "uri": "franchise\/tag\/update\/{id}",
        "name": "franchise.inventory.tags.update"
    },
    {
        "uri": "franchise\/tag\/store",
        "name": "franchise.inventory.tags.store"
    },
    {
        "uri": "franchise\/tag\/delete",
        "name": "franchise.inventory.tags.delete"
    },
    {
        "uri": "franchise\/modifier",
        "name": "franchise.inventory.modifier.index"
    },
    {
        "uri": "franchise\/modifier\/{id}",
        "name": "franchise.inventory.modifier.show"
    },
    {
        "uri": "franchise\/modifier\/export\/{type}",
        "name": "franchise.inventory.modifier.exportAsFile"
    },
    {
        "uri": "franchise\/modifier\/template\/{type}",
        "name": "franchise.inventory.modifier.exportTemplate"
    },
    {
        "uri": "franchise\/modifier\/{id}",
        "name": "franchise.inventory.modifier.update"
    },
    {
        "uri": "franchise\/modifier",
        "name": "franchise.inventory.modifier.delete"
    },
    {
        "uri": "franchise\/modifier\/import",
        "name": "franchise.inventory.modifier.import"
    },
    {
        "uri": "franchise\/modifier\/validate\/{importKey}",
        "name": "franchise.inventory.modifier.validate_data"
    },
    {
        "uri": "franchise\/modifier\/store\/{importKey}",
        "name": "franchise.inventory.modifier.store_data"
    },
    {
        "uri": "franchise\/modifier\/read-data\/{importKey}",
        "name": "franchise.inventory.modifier.readdata"
    },
    {
        "uri": "franchise\/modifier\/import-status\/{importKey}",
        "name": "franchise.inventory.modifier.import_status"
    },
    {
        "uri": "franchise\/customer",
        "name": "franchise.customers.index"
    },
    {
        "uri": "franchise\/customer\/all",
        "name": "franchise.customers.all"
    },
    {
        "uri": "franchise\/customer\/summary",
        "name": "franchise.customers.summary"
    },
    {
        "uri": "franchise\/customer\/transaction\/{id}",
        "name": "franchise.customers.transaction_details"
    },
    {
        "uri": "franchise\/customer\/{id}",
        "name": "franchise.customers.show"
    },
    {
        "uri": "franchise\/customer\/{id}\/transactions",
        "name": "franchise.customers.transactions"
    },
    {
        "uri": "franchise\/customer\/profile\/{id}",
        "name": "franchise.customers.profile"
    },
    {
        "uri": "franchise\/customer\/export-customers\/{type}",
        "name": "franchise.customers.export_customers"
    },
    {
        "uri": "franchise\/customer\/{id}\/export-transactions\/{type}",
        "name": "franchise.customers.export_trans"
    },
    {
        "uri": "franchise\/discount",
        "name": "franchise.setting.discount.index"
    },
    {
        "uri": "franchise\/discount\/{id}",
        "name": "franchise.setting.discount.show"
    },
    {
        "uri": "franchise\/discount\/export\/{type}",
        "name": "franchise.setting.discount.exportAsFile"
    },
    {
        "uri": "franchise\/discount",
        "name": "franchise.setting.discount.store"
    },
    {
        "uri": "franchise\/discount\/{id}",
        "name": "franchise.setting.discount.update"
    },
    {
        "uri": "franchise\/discount",
        "name": "franchise.setting.discount.delete"
    },
    {
        "uri": "franchise\/user\/role",
        "name": "franchise.role.index"
    },
    {
        "uri": "franchise\/user\/role",
        "name": "franchise.role.store"
    },
    {
        "uri": "franchise\/user\/role\/{id}",
        "name": "franchise.role.update"
    },
    {
        "uri": "franchise\/user\/role\/delete",
        "name": "franchise.role.delete"
    },
    {
        "uri": "inventory\/stock-check",
        "name": "inventory.stock-check.index"
    },
    {
        "uri": "inventory\/stock-check\/list",
        "name": "inventory.stock-check.list"
    },
    {
        "uri": "inventory\/stock-check\/show\/{id}",
        "name": "inventory.stock-check.show"
    },
    {
        "uri": "inventory\/stock-check\/variance\/list",
        "name": "inventory.stock-check.variance-list"
    },
    {
        "uri": "inventory\/stock-check\/product\/list\/{id}",
        "name": "inventory.stock-check.product-list"
    },
    {
        "uri": "inventory\/stock-check\/export\/{id}\/{type}",
        "name": "inventory.stock-check.exportAsFile"
    },
    {
        "uri": "inventory\/stock-check\/export\/main\/{type}",
        "name": "inventory.stock-check.exportListAsFile"
    },
    {
        "uri": "inventory\/stock-check\/create",
        "name": "inventory.stock-check.create"
    },
    {
        "uri": "inventory\/stock-check\/update",
        "name": "inventory.stock-check.update"
    },
    {
        "uri": "inventory\/stock-check\/delete",
        "name": "inventory.stock-check.delete"
    },
    {
        "uri": "inventory\/stock-check\/completed",
        "name": "inventory.stock-check.completed"
    },
    {
        "uri": "inventory\/stock-return",
        "name": "inventory.stock-return.index"
    },
    {
        "uri": "inventory\/stock-return\/list",
        "name": "inventory.stock-return.list"
    },
    {
        "uri": "inventory\/stock-return\/show\/{id}",
        "name": "inventory.stock-return.show"
    },
    {
        "uri": "inventory\/stock-return\/product\/list\/{id}",
        "name": "inventory.stock-return.product-list"
    },
    {
        "uri": "inventory\/stock-return\/export\/{id}\/{type}",
        "name": "inventory.stock-return.exportAsFile"
    },
    {
        "uri": "inventory\/stock-return\/export\/main\/{type}",
        "name": "inventory.stock-return.exportListAsFile"
    },
    {
        "uri": "inventory\/stock-return\/create",
        "name": "inventory.stock-return.create"
    },
    {
        "uri": "inventory\/stock-return\/update",
        "name": "inventory.stock-return.update"
    },
    {
        "uri": "inventory\/stock-return\/delete",
        "name": "inventory.stock-return.delete"
    },
    {
        "uri": "inventory\/stock-return\/returned",
        "name": "inventory.stock-return.returned"
    },
    {
        "uri": "inventory\/sync",
        "name": "inventory.sync.index"
    },
    {
        "uri": "inventory\/sync\/sync\/check\/{id}",
        "name": "inventory.sync.sync-check"
    },
    {
        "uri": "inventory\/sync\/{id}",
        "name": "inventory.sync.sync"
    },
    {
        "uri": "inventory\/sync\/outlet",
        "name": "inventory.sync.outlet"
    },
    {
        "uri": "inventory\/sync\/product\/{id}",
        "name": "inventory.sync.product"
    },
    {
        "uri": "inventory\/sync\/variant\/{id}",
        "name": "inventory.sync.variant"
    },
    {
        "uri": "inventory\/sync\/stock\/{id}",
        "name": "inventory.sync.stock"
    },
    {
        "uri": "inventory\/sync\/tag",
        "name": "inventory.sync.tag"
    },
    {
        "uri": "inventory\/sync\/product\/tag\/{id}",
        "name": "inventory.sync.product.tag"
    },
    {
        "uri": "inventory\/monitor",
        "name": "inventory.monitor.index"
    },
    {
        "uri": "inventory\/monitor\/list",
        "name": "inventory.monitor.list"
    },
    {
        "uri": "inventory\/monitor\/stock\/movement\/product\/list\/{stock_id}",
        "name": "inventory.monitor.stock-movement-product-list"
    },
    {
        "uri": "inventory\/monitor\/stock\/batch\/list\/{stock_id}",
        "name": "inventory.monitor.stock-batch-list"
    },
    {
        "uri": "inventory\/monitor\/stock\/cache\/list\/{stock_id}",
        "name": "inventory.monitor.stock-cache-list"
    },
    {
        "uri": "inventory\/monitor\/stock\/deduction\/list\/{stock_id}",
        "name": "inventory.monitor.stock-deduction-list"
    },
    {
        "uri": "inventory\/monitor\/stock\/deduction\/cache\/list\/{stock_id}",
        "name": "inventory.monitor.stock-deduction-cache-list"
    },
    {
        "uri": "inventory\/stock",
        "name": "inventory.stock.index"
    },
    {
        "uri": "inventory\/stock\/list",
        "name": "inventory.stock.list"
    },
    {
        "uri": "inventory\/stock\/show\/{unique_id}",
        "name": "inventory.stock.show"
    },
    {
        "uri": "inventory\/stock\/migrate",
        "name": "inventory.stock.migrate"
    },
    {
        "uri": "inventory\/stock\/export\/{type}",
        "name": "inventory.stock.exportAsFile"
    },
    {
        "uri": "inventory\/stock\/price-checker\/{outlet_id}\/{code}",
        "name": "inventory.stock.price-checker"
    },
    {
        "uri": "inventory\/stock\/validate\/stock\/migration",
        "name": "inventory.stock.validate.stock.migration"
    },
    {
        "uri": "inventory\/stock\/import\/stock\/migration",
        "name": "inventory.stock.import.stock.migration"
    },
    {
        "uri": "inventory\/stock\/import\/template",
        "name": "inventory.stock.import.template"
    },
    {
        "uri": "inventory\/stock\/update",
        "name": "inventory.stock.update"
    },
    {
        "uri": "inventory\/stock\/selector",
        "name": "inventory.stock.selector"
    },
    {
        "uri": "inventory\/audit-trail",
        "name": "inventory.audit-trail.index"
    },
    {
        "uri": "inventory\/audit-trail\/list",
        "name": "inventory.audit-trail.list"
    },
    {
        "uri": "inventory\/audit-trail\/export\/{type}",
        "name": "inventory.audit-trail.exportAsFile"
    },
    {
        "uri": "inventory\/supplier",
        "name": "inventory.supplier.index"
    },
    {
        "uri": "inventory\/supplier\/list",
        "name": "inventory.supplier.list"
    },
    {
        "uri": "inventory\/supplier\/{id}",
        "name": "inventory.supplier.show"
    },
    {
        "uri": "inventory\/supplier\/create",
        "name": "inventory.supplier.create"
    },
    {
        "uri": "inventory\/supplier\/update",
        "name": "inventory.supplier.update"
    },
    {
        "uri": "inventory\/supplier\/delete",
        "name": "inventory.supplier.delete"
    },
    {
        "uri": "inventory\/supplier\/stock\/list",
        "name": "inventory.supplier.stock.list"
    },
    {
        "uri": "inventory\/supplier\/stock\/add",
        "name": "inventory.supplier.stock.add"
    },
    {
        "uri": "inventory\/supplier\/stock\/update",
        "name": "inventory.supplier.stock.update"
    },
    {
        "uri": "inventory\/supplier\/stock\/delete",
        "name": "inventory.supplier.stock.delete"
    },
    {
        "uri": "inventory\/stock-cost",
        "name": "inventory.stock-cost.index"
    },
    {
        "uri": "inventory\/stock-cost\/list",
        "name": "inventory.stock-cost.list"
    },
    {
        "uri": "inventory\/stock-cost\/summary",
        "name": "inventory.stock-cost.summary"
    },
    {
        "uri": "inventory\/stock-cost\/export\/{type}",
        "name": "inventory.stock-cost.exportAsFile"
    },
    {
        "uri": "inventory\/stock-cost\/search\/meta",
        "name": "inventory.stock-cost.search.meta"
    },
    {
        "uri": "inventory\/stock-fifo",
        "name": "inventory.stock-fifo.index"
    },
    {
        "uri": "inventory\/stock-fifo\/list",
        "name": "inventory.stock-fifo.list"
    },
    {
        "uri": "inventory\/stock-receive",
        "name": "inventory.stock-receive.index"
    },
    {
        "uri": "inventory\/stock-receive\/list",
        "name": "inventory.stock-receive.list"
    },
    {
        "uri": "inventory\/stock-receive\/show\/{id}",
        "name": "inventory.stock-receive.show"
    },
    {
        "uri": "inventory\/stock-receive\/product\/list\/{id}",
        "name": "inventory.stock-receive.product-list"
    },
    {
        "uri": "inventory\/stock-receive\/export\/{id}\/{type}",
        "name": "inventory.stock-receive.exportAsFile"
    },
    {
        "uri": "inventory\/stock-receive\/export\/main\/{type}",
        "name": "inventory.stock-receive.exportListAsFile"
    },
    {
        "uri": "inventory\/stock-receive\/create",
        "name": "inventory.stock-receive.create"
    },
    {
        "uri": "inventory\/stock-receive\/update",
        "name": "inventory.stock-receive.update"
    },
    {
        "uri": "inventory\/stock-receive\/delete",
        "name": "inventory.stock-receive.delete"
    },
    {
        "uri": "inventory\/stock-receive\/received",
        "name": "inventory.stock-receive.received"
    },
    {
        "uri": "inventory\/stock-batch\/list\/{stock_id}",
        "name": "inventory.stock-batch.list"
    },
    {
        "uri": "inventory\/stock-movement\/search\/meta\/{supplier}",
        "name": "inventory.stock-movement.search.meta"
    },
    {
        "uri": "inventory\/stock-movement\/search\/status",
        "name": "inventory.stock-movement.search.status"
    },
    {
        "uri": "inventory",
        "name": "inventory.index"
    },
    {
        "uri": "inventory\/dashboard",
        "name": "inventory.dashboard"
    },
    {
        "uri": "inventory\/dashboard\/export\/{type}",
        "name": "inventory.dashboard.exportAsFile"
    },
    {
        "uri": "inventory\/dashboard\/summary",
        "name": "inventory.dashboard.summary"
    },
    {
        "uri": "inventory\/dashboard\/supplier\/distribution",
        "name": "inventory.dashboard.supplier-distribution"
    },
    {
        "uri": "inventory\/dashboard\/inventory\/asset",
        "name": "inventory.dashboard.inventory-asset"
    },
    {
        "uri": "inventory\/dashboard\/inventory\/category\/asset",
        "name": "inventory.dashboard.inventory-category-asset"
    },
    {
        "uri": "inventory\/dashboard\/supplier\/qty",
        "name": "inventory.dashboard.top-supplier-qty"
    },
    {
        "uri": "inventory\/dashboard\/supplier\/cost",
        "name": "inventory.dashboard.top-supplier-cost"
    },
    {
        "uri": "inventory\/fnb\/stock-check",
        "name": "inventory.fnb.stock-check.index"
    },
    {
        "uri": "inventory\/fnb\/stock-check\/list",
        "name": "inventory.fnb.stock-check.list"
    },
    {
        "uri": "inventory\/fnb\/stock-check\/show\/{id}",
        "name": "inventory.fnb.stock-check.show"
    },
    {
        "uri": "inventory\/fnb\/stock-check\/product\/list\/{id}",
        "name": "inventory.fnb.stock-check.product.list"
    },
    {
        "uri": "inventory\/fnb\/stock-check\/export\/{type}",
        "name": "inventory.fnb.stock-check.export"
    },
    {
        "uri": "inventory\/fnb\/stock-check\/export\/stock\/{type}",
        "name": "inventory.fnb.stock-check.export.stock"
    },
    {
        "uri": "inventory\/fnb\/stock-check\/create",
        "name": "inventory.fnb.stock-check.create"
    },
    {
        "uri": "inventory\/fnb\/stock-check\/update",
        "name": "inventory.fnb.stock-check.update"
    },
    {
        "uri": "inventory\/fnb\/stock-check\/commit",
        "name": "inventory.fnb.stock-check.commit"
    },
    {
        "uri": "inventory\/fnb\/stock-check\/delete",
        "name": "inventory.fnb.stock-check.delete"
    },
    {
        "uri": "inventory\/fnb\/stock-check\/generate\/stocks\/{id}\/{outletId}",
        "name": "inventory.fnb.stock-check.generate.stocks"
    },
    {
        "uri": "inventory\/fnb",
        "name": "inventory.fnb.index"
    },
    {
        "uri": "inventory\/fnb\/low\/ingredient\/list",
        "name": "inventory.fnb.low.ingredient.list"
    },
    {
        "uri": "inventory\/fnb\/low\/ingredient\/export\/{type}",
        "name": "inventory.fnb.low.ingredient.export"
    },
    {
        "uri": "inventory\/fnb\/low\/stock\/list",
        "name": "inventory.fnb.low.stock.list"
    },
    {
        "uri": "inventory\/fnb\/low\/stock\/export\/{type}",
        "name": "inventory.fnb.low.stock.export"
    },
    {
        "uri": "inventory\/fnb\/low\/end\/product\/list",
        "name": "inventory.fnb.low.end.product.list"
    },
    {
        "uri": "inventory\/fnb\/low\/end\/product\/export\/{type}",
        "name": "inventory.fnb.low.end.product.export"
    },
    {
        "uri": "inventory\/fnb\/low\/notification\/{id}",
        "name": "inventory.fnb.low.notification"
    },
    {
        "uri": "inventory\/fnb\/total",
        "name": "inventory.fnb.total"
    },
    {
        "uri": "inventory\/fnb\/wasted\/ingredient",
        "name": "inventory.fnb.wasted.ingredient.index"
    },
    {
        "uri": "inventory\/fnb\/wasted\/ingredient\/list",
        "name": "inventory.fnb.wasted.ingredient.list"
    },
    {
        "uri": "inventory\/fnb\/wasted\/ingredient\/export\/{type}",
        "name": "inventory.fnb.wasted.ingredient.export"
    },
    {
        "uri": "inventory\/fnb\/stock-return",
        "name": "inventory.fnb.stock-return.index"
    },
    {
        "uri": "inventory\/fnb\/stock-return\/list",
        "name": "inventory.fnb.stock-return.list"
    },
    {
        "uri": "inventory\/fnb\/stock-return\/show\/{id}",
        "name": "inventory.fnb.stock-return.show"
    },
    {
        "uri": "inventory\/fnb\/stock-return\/product\/list\/{id}",
        "name": "inventory.fnb.stock-return.product.list"
    },
    {
        "uri": "inventory\/fnb\/stock-return\/export\/{type}",
        "name": "inventory.fnb.stock-return.export"
    },
    {
        "uri": "inventory\/fnb\/stock-return\/export\/stock\/{type}",
        "name": "inventory.fnb.stock-return.export.stock"
    },
    {
        "uri": "inventory\/fnb\/stock-return\/create",
        "name": "inventory.fnb.stock-return.create"
    },
    {
        "uri": "inventory\/fnb\/stock-return\/update",
        "name": "inventory.fnb.stock-return.update"
    },
    {
        "uri": "inventory\/fnb\/stock-return\/commit",
        "name": "inventory.fnb.stock-return.commit"
    },
    {
        "uri": "inventory\/fnb\/stock-return\/delete",
        "name": "inventory.fnb.stock-return.delete"
    },
    {
        "uri": "inventory\/fnb\/sync",
        "name": "inventory.fnb.sync.index"
    },
    {
        "uri": "inventory\/fnb\/sync\/outlet",
        "name": "inventory.fnb.sync.outlet"
    },
    {
        "uri": "inventory\/fnb\/sync\/product\/{id}",
        "name": "inventory.fnb.sync.product"
    },
    {
        "uri": "inventory\/fnb\/sync\/variant\/{id}",
        "name": "inventory.fnb.sync.variant"
    },
    {
        "uri": "inventory\/fnb\/sync\/stock\/{id}",
        "name": "inventory.fnb.sync.stock"
    },
    {
        "uri": "inventory\/fnb\/sync\/tag",
        "name": "inventory.fnb.sync.tag"
    },
    {
        "uri": "inventory\/fnb\/sync\/product\/tag\/{id}",
        "name": "inventory.fnb.sync.product.tag"
    },
    {
        "uri": "inventory\/fnb\/sync\/ingredient\/{id}",
        "name": "inventory.fnb.sync.ingredient"
    },
    {
        "uri": "inventory\/fnb\/sync\/recipe\/{id}",
        "name": "inventory.fnb.sync.recipe"
    },
    {
        "uri": "inventory\/fnb\/sync\/modifier\/{id}",
        "name": "inventory.fnb.sync.modifier"
    },
    {
        "uri": "inventory\/fnb\/sync\/modifier\/recipe\/{id}",
        "name": "inventory.fnb.sync.modifier.recipe"
    },
    {
        "uri": "inventory\/fnb\/stock",
        "name": "inventory.fnb.stock.index"
    },
    {
        "uri": "inventory\/fnb\/stock\/list",
        "name": "inventory.fnb.stock.list"
    },
    {
        "uri": "inventory\/fnb\/stock\/product\/list",
        "name": "inventory.fnb.stock.product.list"
    },
    {
        "uri": "inventory\/fnb\/stock\/ingredient\/list",
        "name": "inventory.fnb.stock.ingredient.list"
    },
    {
        "uri": "inventory\/fnb\/stock\/selector",
        "name": "inventory.fnb.stock.selector"
    },
    {
        "uri": "inventory\/fnb\/stock\/export\/{type}",
        "name": "inventory.fnb.stock.export"
    },
    {
        "uri": "inventory\/fnb\/stock\/ingredient\/export\/{type}",
        "name": "inventory.fnb.stock.ingredient.export"
    },
    {
        "uri": "inventory\/fnb\/stock\/product\/export\/{type}",
        "name": "inventory.fnb.stock.product.export"
    },
    {
        "uri": "inventory\/fnb\/stock\/show\/{id}\/{endProduct?}",
        "name": "inventory.fnb.stock.show"
    },
    {
        "uri": "inventory\/fnb\/stock\/update",
        "name": "inventory.fnb.stock.update"
    },
    {
        "uri": "inventory\/fnb\/audit-trail",
        "name": "inventory.fnb.audit-trail.index"
    },
    {
        "uri": "inventory\/fnb\/audit-trail\/list",
        "name": "inventory.fnb.audit-trail.list"
    },
    {
        "uri": "inventory\/fnb\/audit-trail\/export\/{type}",
        "name": "inventory.fnb.audit-trail.export"
    },
    {
        "uri": "inventory\/fnb\/supplier",
        "name": "inventory.fnb.supplier.index"
    },
    {
        "uri": "inventory\/fnb\/supplier\/list",
        "name": "inventory.fnb.supplier.list"
    },
    {
        "uri": "inventory\/fnb\/supplier\/show\/{id}",
        "name": "inventory.fnb.supplier.show"
    },
    {
        "uri": "inventory\/fnb\/supplier\/country\/list",
        "name": "inventory.fnb.supplier.country.list"
    },
    {
        "uri": "inventory\/fnb\/supplier\/create",
        "name": "inventory.fnb.supplier.create"
    },
    {
        "uri": "inventory\/fnb\/supplier\/update",
        "name": "inventory.fnb.supplier.update"
    },
    {
        "uri": "inventory\/fnb\/supplier\/delete",
        "name": "inventory.fnb.supplier.delete"
    },
    {
        "uri": "inventory\/fnb\/stock-receive",
        "name": "inventory.fnb.stock-receive.index"
    },
    {
        "uri": "inventory\/fnb\/stock-receive\/list",
        "name": "inventory.fnb.stock-receive.list"
    },
    {
        "uri": "inventory\/fnb\/stock-receive\/show\/{id}",
        "name": "inventory.fnb.stock-receive.show"
    },
    {
        "uri": "inventory\/fnb\/stock-receive\/product\/list\/{id}",
        "name": "inventory.fnb.stock-receive.product.list"
    },
    {
        "uri": "inventory\/fnb\/stock-receive\/export\/{type}",
        "name": "inventory.fnb.stock-receive.export"
    },
    {
        "uri": "inventory\/fnb\/stock-receive\/export\/stock\/{type}",
        "name": "inventory.fnb.stock-receive.export.stock"
    },
    {
        "uri": "inventory\/fnb\/stock-receive\/create",
        "name": "inventory.fnb.stock-receive.create"
    },
    {
        "uri": "inventory\/fnb\/stock-receive\/update",
        "name": "inventory.fnb.stock-receive.update"
    },
    {
        "uri": "inventory\/fnb\/stock-receive\/commit",
        "name": "inventory.fnb.stock-receive.commit"
    },
    {
        "uri": "inventory\/fnb\/stock-receive\/delete",
        "name": "inventory.fnb.stock-receive.delete"
    },
    {
        "uri": "inventory\/fnb\/consumed\/ingredient",
        "name": "inventory.fnb.consumed.ingredient.index"
    },
    {
        "uri": "inventory\/fnb\/consumed\/ingredient\/list",
        "name": "inventory.fnb.consumed.ingredient.list"
    },
    {
        "uri": "inventory\/fnb\/consumed\/ingredient\/export\/{type}",
        "name": "inventory.fnb.consumed.ingredient.export"
    }
],
            prefix: '',

            route : function (name, parameters, route) {
                route = route || this.getByName(name);

                if ( ! route ) {
                    return undefined;
                }

                return this.toRoute(route, parameters);
            },

            url: function (url, parameters) {
                parameters = parameters || [];

                var uri = url + '/' + parameters.join('/');

                return this.getCorrectUrl(uri);
            },

            toRoute : function (route, parameters) {
                var uri = this.replaceNamedParameters(route.uri, parameters);
                var qs  = this.getRouteQueryString(parameters);

                if (this.absolute && this.isOtherHost(route)){
                    return "//" + route.host + "/" + uri + qs;
                }

                return this.getCorrectUrl(uri + qs);
            },

            isOtherHost: function (route){
                return route.host && route.host != window.location.hostname;
            },

            replaceNamedParameters : function (uri, parameters) {
                uri = uri.replace(/\{(.*?)\??\}/g, function(match, key) {
                    if (parameters.hasOwnProperty(key)) {
                        var value = parameters[key];
                        delete parameters[key];
                        return value;
                    } else {
                        return match;
                    }
                });

                // Strip out any optional parameters that were not given
                uri = uri.replace(/\/\{.*?\?\}/g, '');

                return uri;
            },

            getRouteQueryString : function (parameters) {
                var qs = [];
                for (var key in parameters) {
                    if (parameters.hasOwnProperty(key)) {
                        qs.push(key + '=' + parameters[key]);
                    }
                }

                if (qs.length < 1) {
                    return '';
                }

                return '?' + qs.join('&');
            },

            getByName : function (name) {
                for (var key in this.routes) {
                    if (this.routes.hasOwnProperty(key) && this.routes[key].name === name) {
                        return this.routes[key];
                    }
                }
            },

            getByAction : function(action) {
                for (var key in this.routes) {
                    if (this.routes.hasOwnProperty(key) && this.routes[key].action === action) {
                        return this.routes[key];
                    }
                }
            },

            getCorrectUrl: function (uri) {
                var url = this.prefix + '/' + uri.replace(/^\/?/, '');

                if ( ! this.absolute) {
                    return url;
                }

                return this.rootUrl.replace('/\/?$/', '') + url;
            }
        };

        var getLinkAttributes = function(attributes) {
            if ( ! attributes) {
                return '';
            }

            var attrs = [];
            for (var key in attributes) {
                if (attributes.hasOwnProperty(key)) {
                    attrs.push(key + '="' + attributes[key] + '"');
                }
            }

            return attrs.join(' ');
        };

        var getHtmlLink = function (url, title, attributes) {
            title      = title || url;
            attributes = getLinkAttributes(attributes);

            return '<a href="' + url + '" ' + attributes + '>' + title + '</a>';
        };

        return {
            // Generate a url for a given controller action.
            // laroute.action('HomeController@getIndex', [params = {}])
            action : function (name, parameters) {
                parameters = parameters || {};

                return routes.route(name, parameters, routes.getByAction(name));
            },

            // Generate a url for a given named route.
            // laroute.route('routeName', [params = {}])
            route : function (route, parameters) {
                parameters = parameters || {};

                return routes.route(route, parameters);
            },

            // Generate a fully qualified URL to the given path.
            // laroute.route('url', [params = {}])
            url : function (route, parameters) {
                parameters = parameters || {};

                return routes.url(route, parameters);
            },

            // Generate a html link to the given url.
            // laroute.link_to('foo/bar', [title = url], [attributes = {}])
            link_to : function (url, title, attributes) {
                url = this.url(url);

                return getHtmlLink(url, title, attributes);
            },

            // Generate a html link to the given route.
            // laroute.link_to_route('route.name', [title=url], [parameters = {}], [attributes = {}])
            link_to_route : function (route, title, parameters, attributes) {
                var url = this.route(route, parameters);

                return getHtmlLink(url, title, attributes);
            },

            // Generate a html link to the given controller action.
            // laroute.link_to_action('HomeController@getIndex', [title=url], [parameters = {}], [attributes = {}])
            link_to_action : function(action, title, parameters, attributes) {
                var url = this.action(action, parameters);

                return getHtmlLink(url, title, attributes);
            }

        };

    }).call(this);

    /**
     * Expose the class either via AMD, CommonJS or the global object
     */
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return laroute;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = laroute;
    }
    else {
        window.laroute = laroute;
    }

}).call(this);




// WEBPACK FOOTER //
// ./resources/assets/js/laroute.js